<template>
  <div class="loading" v-bind:class="{ isActive: this.isActive }">
    <div class="load">
      <div class="animation"><div class="circle one"></div></div>
      <div class="animation"><div class="circle two"></div></div>
      <div class="animation"><div class="circle three"></div></div>
      <div class="animation"><div class="circle four"></div></div>
      <div class="animation"><div class="circle five"></div></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Loading',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Loading.vue